module.exports = __webpack_public_path__ + "img/scene-tongue-twister.cc30cfba.jpg";